import type { Component } from "solid-js";
import type { IconProps } from "./types";

const CampaignIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-.665a1.086 1.086 0 00-.97 0l-1.331.665zM7.5 14.25v-3a6 6 0 00-1.875-4.375 9.017 9.017 0 116.22-6.22 6.77 6.77 0 01-3.05-.814 5.028 5.028 0 00-6.5 6.5 8.25 8.25 0 00.2 5.319zm2.72-1.861c.545.766.16 1.861-.749 1.861h-2.98c-.546 0-1.059-.26-1.386-.7-.327-.44-.327-1.02 0-1.46.327-.44.84-.7 1.386-.7H7.374c.899 0 1.806-.615 2.346-1.39z"
      />
    </svg>
  );
};

export default CampaignIcon;
